import { render, staticRenderFns } from "./WateDeliveryForm.vue?vue&type=template&id=1b175fde&scoped=true&"
import script from "./WateDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./WateDeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./WateDeliveryForm.vue?vue&type=style&index=0&id=1b175fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b175fde",
  null
  
)

export default component.exports